module.exports = __webpack_public_path__ + "resources/img/img_nginx2_m_en.110a07291ee00ce6368130687273d5b5.png";